import { render, staticRenderFns } from "./uploadIndex.vue?vue&type=template&id=581ce663&scoped=true"
import script from "./uploadIndex.vue?vue&type=script&lang=js"
export * from "./uploadIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581ce663",
  null
  
)

export default component.exports